import { render } from "./index.vue?vue&type=template&id=1679ab52&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=1679ab52&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1679ab52"]])

export default __exports__